import { gql } from '@apollo/client';

const PROJECTS = gql`
    query Projects($profileId: Int!, $pagination: PaginationOffsetInput!, $isAtsProjects: Boolean!) {
        projects(profileId: $profileId, pagination: $pagination, isAtsProjects: $isAtsProjects) {
            projects {
                id
                name
                language1 {
                    code
                    name
                    nativeName
                }
                language2 {
                    code
                    name
                    nativeName
                }
                enabledProducts {
                    id
                    name
                    colourTheme
                }
                isTestApiProject
            }
            paginationInfo {
                perPage
                maxPage
                currentPage
                totalCount
                previousPage
            }
        }
    }
`;

export default PROJECTS;
